import { HistoryOutlined } from "@ant-design/icons";
import { Modal, Spin } from "antd";
import i18n from "i18next";
import type { FC } from "react";
import { useCallback, useState } from "react";

import { SecondaryButton } from "../Buttons/components/ActionButton";
import { useLazyEntityHistoryQuery } from "../ChangeLog/changeLogServerApi";
import { ChangeLogTable } from "../ChangeLog/components/ChangeLogTable";

export type HistoryButtonProps = {
    url?: string;
};

export const HistoryButton: FC<HistoryButtonProps> = ({ url }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fetchHistory, { data, isFetching }] = useLazyEntityHistoryQuery();

    const onClick = useCallback(() => {
        setIsModalVisible(true);
        fetchHistory(url ?? "");
    }, [fetchHistory, url]);

    const onClose = useCallback(() => {
        setIsModalVisible(false);
    }, []);

    if (!url) return null;

    return (
        <>
            <SecondaryButton name="history_button" onClick={onClick} disabled={false}>
                <HistoryOutlined />
                {i18n.t("button.history")}
            </SecondaryButton>
            <Modal open={isModalVisible} title={i18n.t("history.modal.title")} onCancel={onClose} footer={null} width="80%">
                <Spin spinning={isFetching}>
                    <ChangeLogTable datasource={data} />
                </Spin>
            </Modal>
        </>
    );
};
